<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="white">
      <v-toolbar-title>Mobile Recharge Rejected</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        @keyup.enter="paginationMethod"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-card>
                <v-card-text>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Dasher Profile Information</div>
                  </v-card-title>
                  <!-- <v-img
                      class="my-3"
                      contain
                      aspect-ratio="2"
                    >
                    
                      <v-layout
                        column
                        fill-height
                      >
                        <v-spacer></v-spacer>

                        <v-card-title class="gray--text pl-5 pt-5">
                          <div class="display-1 pl-5 pt-5"><span class="green--text">{{editedItem.name}}</span></div>
                        </v-card-title>
                      </v-layout>
                    </v-img> -->

                  <v-list two-line>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">phone</v-icon>
                        <!-- <v-icon color="indigo">mail</v-icon> -->
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ editedItem.phone }}
                        </v-list-tile-title>
                        <!-- <v-list-tile-title>{{editedItem.email}}</v-list-tile-title> -->
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-icon color="indigo" v-if="editedItem.active == 1">
                          radio_button_checked
                        </v-icon>
                        <v-icon color="indigo" v-else>
                          radio_button_unchecked
                        </v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>Active</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-divider inset></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">location_on</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>address</v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="editedItem.address != null"
                        >
                          {{ editedItem.address }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Coin & Point Details</div>
                  </v-card-title>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Total Coin
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.total_coin }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Total Point
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.total_point }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Ranking Level
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.level }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Ranking Name
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.rank_name }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Mobile Number
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.account_number }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Request Amount
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.withdraw_amount }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Rejection Reason
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.comment }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="success" @click="verifyItem(editedItem)">
                  Accept
                </v-btn>
                <v-btn color="warning" @click="rejectItem(editedItem)">
                  Reject
                </v-btn>
                <v-btn color="red" @click="close">Close</v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
    </v-toolbar>
    <div v-if="isLoaded">
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.dataset3.total < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataset3.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.dataset3.total > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.user_id }}</td>
          <td>{{ props.item.dasher_name }}</td>
          <td>{{ props.item.account_number }}</td>
          <td>{{ props.item.withdraw_amount }}</td>
          <td>{{ props.item.carrier_name }}</td>
          <td>{{ props.item.connection_name }}</td>
          <td>{{ props.item.message }}</td>
          <td>{{ props.item.canceled_by }}</td>
          <td>{{ props.item.canceled_at }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="viewItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataset3.from }} - {{ indexData.dataset3.to }} of
          {{ indexData.dataset3.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.dataset3.current_page"
            :length="indexData.dataset3.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      apiUrl: "mr-status",
      sl: 1,
      headers: [
        { text: "ID", align: "left", value: "id" },
        { text: "Dasher ID", align: "left", value: "user_id" },
        { text: "Dasher Name", value: "dasher_name" },
        { text: "Mobile Number", value: "account_number" },
        { text: "Request Amount", align: "left", value: "withdraw_amount" },
        { text: "Carrier Name", value: "carrier_name" },
        { text: "Connection Name", value: "connection_name" },
        { text: "Message", value: "message" },
        { text: "Rejected By", value: "canceled_by" },
        { text: "Rejected At", value: "canceled_at" },
        { text: "Actions", align: "center", value: "name", sortable: false },
      ],
      loading: false,
      search: "",
      pagination: {
        rowsPerPage: 10,
      },
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        rowsPerPage: 10,
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.dataset3) {
          return true;
        } else {
          return false;
        }
      },
    },

    watch: {
      pagination() {
        this.onPageChange();
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.$store.dispatch("changeWithdrawStatus", [this.apiUrl, 3, "", 1, this.pagination.rowsPerPage]);
    },

    methods: {
      initialize() {
        this.paginationMethod();

        // this.alertMsg = true
        // setTimeout(() => {
        //   this.alertMsg = false
        // }, 300)
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      viewItem(item) {
        this.editedIndex = this.indexData.dataset3.data.indexOf(item);
        this.editedItem = Object.assign([], item);
        this.dialog = true;
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        // console.log(this.search)
        this.loading = true;

        if (this.search) {
          this.pagination.rowsPerPage=1000;
          this.$store.dispatch("changeWithdrawStatus", [this.apiUrl, 3, this.search, this.indexData.dataset3.current_page, this.pagination.rowsPerPage]);
          this.loading = this.indexData.dataset3.data ? false : true;
        } else {
          if(this.pagination.rowsPerPage==1000){
              this.pagination.rowsPerPage=10;
          }
          this.$store.dispatch("changeWithdrawStatus", [this.apiUrl, 3, this.search, this.indexData.dataset3.current_page, this.pagination.rowsPerPage]);
          this.loading = !this.indexData.dataset3.error ? false : true;
        }
        this.dialog = false;
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
